import { ICustomerRecommendationsRepository } from 'modules/customer/domain/repositories';
import {
  IVectisRecommendation,
  Recommendation,
} from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

const PAGE_SIZE = 5;

export default class VectisCustomerRecommendationsRepository
  implements ICustomerRecommendationsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findAll: ICustomerRecommendationsRepository['findAll'] = async ({
    customerId,
    page,
  }) => {
    const { totalPages, data } = await this.httpProvider.get<{
      totalPages: number;
      data: IVectisRecommendation[];
    }>(`/clientes/${customerId}/indicacoes`, {
      params: { page, size: PAGE_SIZE },
    });

    return {
      totalPages,
      recommendations: data.map(
        recommendation => new Recommendation(recommendation),
      ),
    };
  };
}
